import { useAuth } from "../context/AuthContext";
import { canAccessRoute, getTeacherPermissions } from "./temaRoutePermissions";
import { RouteFallback } from "./RouteFallback";

export function ProtectedRoute({ route, children }) {
  const { isAuthenticated } = useAuth();
  const permissions = getTeacherPermissions(isAuthenticated);

  if (!route) {
    return <RouteFallback kind="not-found" />;
  }

  if (route.id === "not-found") {
    return <RouteFallback kind="not-found" hash={window.location.hash} />;
  }

  if (!canAccessRoute(route, { isAuthenticated, permissions })) {
    return (
      <RouteFallback
        kind={isAuthenticated ? "unauthorized" : "auth-required"}
        routeLabel={route.breadcrumbs?.at(-1)?.label}
      />
    );
  }

  return children;
}
